import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

type SummaryIconName = "lock" | "eye-open";

interface VisibilitySummaryRowProps {
  emphasis: string;
  iconName: SummaryIconName;
  text: string;
}

export const VisibilitySummaryRow = ({
  emphasis,
  iconName,
  text,
}: VisibilitySummaryRowProps) => (
  <div className="flex items-start gap-x-2">
    <Icon name={iconName} size="sm" className="mt-0.5 shrink-0" />
    <Typography variant="body-sm" color="secondary">
      <Typography variant="label-sm" component="span" color="primary">
        {emphasis}
      </Typography>{" "}
      {text}
    </Typography>
  </div>
);
